import { render } from "./PartnerStoreDetails.vue?vue&type=template&id=29bf76dc&scoped=true&ts=true"
import script from "./PartnerStoreDetails.vue?vue&type=script&lang=ts"
export * from "./PartnerStoreDetails.vue?vue&type=script&lang=ts"

import "./PartnerStoreDetails.vue?vue&type=style&index=0&id=29bf76dc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29bf76dc"]])

export default __exports__